export const Toastrght = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.16669 9.99935H15.8334M15.8334 9.99935L10 4.16602M15.8334 9.99935L10 15.8327"
      stroke="#2469F3"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
